import { Store } from "common/data/store.logic";
import { ProcessInterfacesService } from "management/process-interfaces/process-interfaces.service";
import { ParamMap } from "@angular/router";
import { InterfaceState } from "management/process-interfaces/process-interfaces.component";

type ProcessInterfaceWorkspace = stages.management.interfaces.ProcessInterfaceWorkspace;
type ProcessInterfaceWorkspaceSelectionOverview =
	stages.management.interfaces.ProcessInterfaceWorkspaceSelectionOverview;
type ReleasePreviewSetting = stages.process.subcomponent.interfaces.core.ReleasePreviewSetting;

export class WorkspaceListStore implements Store<ProcessInterfaceWorkspace> {
	_showOnlyChanges: boolean = false;
	_withWorkflowPolicy: boolean = false;
	_releasePreviewSetting: ReleasePreviewSetting = "OFF";

	private readonly dummyPage = {
		items: [],
		page: 1,
		pageSize: this.pageSize,
		totalItemCount: 100,
		totalPageCount: 1,
		metadata: [],
		actions: {},
	};

	set showOnlyChanges(showOnlyChanges: boolean) {
		this._showOnlyChanges = showOnlyChanges;
	}

	set withWorkflowPolicy(withWorkflowPolicy: boolean) {
		this._withWorkflowPolicy = withWorkflowPolicy;
	}

	set releasePreviewSetting(releasePreviewSetting: ReleasePreviewSetting) {
		this._releasePreviewSetting = releasePreviewSetting;
	}

	constructor(
		private processInterfacesService: ProcessInterfacesService,
		private pageSize: number,
		withWorkflowPolicy: boolean,
		releasePreviewSetting: ReleasePreviewSetting,
	) {
		this.withWorkflowPolicy = withWorkflowPolicy;
		this.releasePreviewSetting = releasePreviewSetting;
	}

	async getPage(
		pageIndex: number,
		_workspaceId: string,
		_pv: string,
		paramMap: ParamMap,
		queryParamMap: ParamMap,
	): Promise<SecuredPagedResultAndInfo<ProcessInterfaceWorkspace, ProcessInterfaceWorkspaceSelectionOverview[]>> {
		const processVersionToView: string = queryParamMap.has("pvForInterfaces")
			? queryParamMap.get("pvForInterfaces")!.toString()
			: paramMap.get("processVersion")!.toString();

		const processVersionToCompareWith = this._showOnlyChanges ? "_vv" : processVersionToView;

		const currentTabName = paramMap.get("interfaceState");
		if (!this.isForNewTab(currentTabName)) {
			// ST-36698: Avoid double requests on tab change because process-interfaces-workspace-list.component also makes a request
			return this.dummyPage;
		}
		return this.processInterfacesService.loadMoreWorkspaces(
			pageIndex,
			this.pageSize,
			this._showOnlyChanges,
			this._releasePreviewSetting,
			paramMap.get("workspaceId")!,
			processVersionToView,
			processVersionToCompareWith,
			this._withWorkflowPolicy,
		);
	}

	private isForNewTab(currentTabName: string | null): boolean {
		return (
			!currentTabName ||
			(currentTabName === InterfaceState.MODIFIED && this._showOnlyChanges) ||
			(currentTabName === InterfaceState.ALL && !this._showOnlyChanges)
		);
	}
}
